import { useState } from "react";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDistance } from "date-fns";
import { NoteItem } from "../../../queries/models/note-item.model";
import { FileDownload } from "../FileDownload";
import { ImageWrapper } from "../ImageWrapper";
import { GalleryPreview } from "../GalleryPreview/gallery-preview";

export function NoteItemComponent(item: NoteItem) {
  const [activeIndex, setActiveIndex] = useState<number>();
  return (
    <>
      <div
        className="flex mx-2 mt-2"
        style={{ width: "calc(100% - 1rem)" }}
      >
        <div
          className="pt-2"
          style={{ width: "50px" }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              fontSize: "25px",
              borderRadius: "100%",
              backgroundColor: "var(--primary-color)",
            }}
            className="justify-content-center align-items-center flex shadow-3"
          >
            <FontAwesomeIcon
              icon={faUser}
              style={{
                color: "white",
              }}
            />
          </div>
        </div>

        <div
          style={{
            width: "calc(100% - 50px - 0.5rem)",
            marginLeft: "0.5rem",
            backgroundColor: "#EDEDED",
            borderRadius: "12px",
          }}
          className="shadow-3"
        >
          <div
            className="h-2rem grid grid-nogutter p-1"
            style={{ gridTemplateColumns: "auto 1fr" }}
          >
            <div className="h-full text-xl font-medium">
              {item.user?.username}
            </div>
            <div className="h-full text-sm ml-2 flex align-items-end">
              <div>
                {`${formatDistance(new Date(item.date), new Date(), {
                  addSuffix: true,
                })}`}
              </div>
            </div>
          </div>
          <div className="flex justify-between pb-1">
            <div className="pl-2">{item.message}</div>
            <div className="pl-2 pr-2 flex-grow-1 min-w-0">
              <div className="flex justify-content-end flex-wrap">
                {item.images && activeIndex !== undefined && (
                  <GalleryPreview
                    images={item.images}
                    activeIndex={activeIndex}
                    onItemChange={(e) => setActiveIndex(e)}
                    onClose={() => setActiveIndex(undefined)}
                  />
                )}

                {item.images &&
                  item.images.map((image, index) => {
                    let imgEl = (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setActiveIndex(index);
                        }}
                      >
                        <ImageWrapper
                          imageSrc={image.thumbnailSrc}
                          width="64px"
                          height="48px"
                        />
                      </div>
                    );

                    return <div key={index}>{imgEl}</div>;
                  })}
              </div>
              <div className="flex flex-column align-items-end pr-2">
                {item.files?.map((x) => (
                  <FileDownload
                    key={x.id}
                    file={x}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
